// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xZobh","title":"styles_title__vwi9I","OneValue":"styles_OneValue__T9YSU","img":"styles_img__TrYBj","content":"styles_content__CUc24"};